import phoneNumberCountryFragmentRawString from '../PhoneNumberCountryFragment.graphql'

export const phoneNumberCountryFragmentString = phoneNumberCountryFragmentRawString

export type PhoneNumberCountryFragment = {
  name: string
  isoCode: string
  callingCode: number
}

export const isPhoneNumberCountryFragment = (
  fragment: any,
): fragment is PhoneNumberCountryFragment =>
  fragment &&
  typeof fragment.name === 'string' &&
  typeof fragment.isoCode === 'string' &&
  typeof fragment.callingCode === 'number'
